var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22142 19.2257L1.59042 12.5937C1.06019 12.034 0.769273 11.2895 0.779561 10.5186C0.789849 9.74758 1.10053 9.01108 1.64551 8.46578C2.19049 7.92038 2.92676 7.60917 3.69768 7.59833C4.4686 7.58749 5.21332 7.87787 5.77342 8.40768L9.99145 12.6257L17.8914 2.0927C18.1245 1.78153 18.4167 1.51934 18.7512 1.32108C19.0857 1.12283 19.4561 0.992396 19.841 0.937236C20.2258 0.882086 20.6177 0.903276 20.9945 0.999606C21.3712 1.09595 21.7253 1.26554 22.0364 1.4987C22.3475 1.73186 22.6098 2.02403 22.8081 2.35852C23.0063 2.69302 23.1367 3.06328 23.1918 3.44818C23.247 3.83308 23.2258 4.22507 23.1295 4.60178C23.0331 4.97849 22.8636 5.33253 22.6304 5.6437L12.6834 18.9087C12.4289 19.248 12.1045 19.5286 11.7319 19.7316C11.3595 19.9346 10.9478 20.0552 10.5247 20.0853C10.1017 20.1153 9.67705 20.0542 9.27966 19.9059C8.88227 19.7576 8.52138 19.5256 8.22142 19.2257Z",
    fill: "#83F068",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.e0168cbcc02c90e1e813f8b4b7da345e.svg";
export { ForwardRef as ReactComponent };